import plans from "_shared/constants/plans";
import React, { createContext, useContext, useEffect, useState } from "react";
import { Ticker, useUserTickersQuery } from "../../../_shared/graphql";
import UserTickersModal from "../components/Modal/UserTickersModal";
import { useSubscriptionsContext } from "./SubscriptionsContext";

const TickersContext = createContext({
  openTickerModal: () => {},
  tickerCount: 0,
});

export const TickersProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [tickerModalOpen, setTickerModalOpen] = useState(false);
  const [tickerLimit, setTickerLimit] = useState(Infinity);

  const { selectedPlanIndex, cancelDowngrade } = useSubscriptionsContext();

  const { data: userTickersData } = useUserTickersQuery();

  useEffect(() => {
    const plan = plans[selectedPlanIndex];
    setTickerLimit(plan.tickerLimit);
  }, [selectedPlanIndex]);

  return (
    <TickersContext.Provider
      value={{
        openTickerModal: () => {
          setTickerModalOpen(true);
        },
        tickerCount: userTickersData?.ticker.length ?? 0,
      }}
    >
      {children}
      {userTickersData && (
        <UserTickersModal
          userTickers={userTickersData.ticker as Ticker[]}
          isOpen={
            // show when user opens themselves or if selected plan is over the ticker limit
            tickerModalOpen
          }
          onClose={() => {
            if (userTickersData.ticker.length > tickerLimit) {
              cancelDowngrade();
            }
            setTickerModalOpen(false);
          }}
          tickerLimit={tickerLimit}
        />
      )}
    </TickersContext.Provider>
  );
};

export const useTickersContext = () => useContext(TickersContext);
